import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home.vue'
import Login from '@/components/Login.vue'
import Inscription from '@/components/Inscription.vue'
import Profil from '@/components/Profil.vue'
import Soumissions from '@/components/Soumissions.vue'
import EditSoumission from '@/components/EditSoumission.vue'
import ViewSoumission from '@/components/ViewSoumission.vue'
import Product from '@/components/Product.vue'
import CreatePlan from '@/components/CreatePlan.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/connexion/',
      name: 'Login',
      component: Login
    },
    {
      path: '/inscription/',
      name: 'Inscription',
      component: Inscription
    },
    {
      path: '/profil/',
      name: 'Profil',
      component: Profil,
      beforeEnter: RequireToken
    },
    {
      path: '/soumissions/',
      name: 'Soumissions',
      component: Soumissions,
      beforeEnter: RequireToken
    },
    {
      path: '/soumissions/create/',
      name: 'CreatePlan',
      component: CreatePlan
    },
    {
      path: '/soumissions/edit/:sid/',
      name: 'EditSoumission',
      component: EditSoumission
    },
    {
      path: '/soumissions/view/:sid/',
      name: 'ViewSoumission',
      component: ViewSoumission,
      beforeEnter: RequireToken
    },
    {
      path: '/soumissions/addproduct/:sid/',
      name: 'Product',
      component: Product,
      beforeEnter: RequireToken
    }
  ]
})

function RequireToken(to, from, next) {

  var token = localStorage.getItem('token')

  if (token) {
    next()
  } else {
    next(false)
    alert('Vous devez être connecté pour pouvoir accéder à cette section. Connectez-vous ou inscrivez-vous!')
  }

}



// WEBPACK FOOTER //
// ./src/router/index.js